import { Icon } from "@utp/react-components-prod";
import IconAlert from "assets/img/alert-icon.svg";
import { URL_OFFICE_ADMISSION } from "utils/ConstantsAndNum";

const Blockquote = () => {
  const transaction = localStorage.getItem("DTransaction");
  return (
    <div className="mt-8 bg-cyan-10 text-color-02 rounded-default py-4 px-8 flex items-start">
      <img src={IconAlert} alt="alert" className="mr-2" />
      <div className="ml-12">
        <p className="text-color-02 leading-normal">
          Si el problema persiste, toma una captura de pantalla de este error,
          adjunta evidencia y repórtalo en la{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={URL_OFFICE_ADMISSION}
            className="text-color-primary font-bold underline"
          >
            Oficina de admisión <Icon iconName="external-link" size={16} />
          </a>{" "}
          seleccionando la opción:{" "}
          <span className="font-bold">
            Trámites a realizar &gt; Trámites Admisión &gt; Examen de Admisión.
          </span>
        </p>
        {transaction !== "NOT_FOUND" && (
          <p className="mt-4 text-color-02">
            <span className="font-bold">Código de error:</span>{" "}
            {transaction}
          </p>
        )}
      </div>
    </div>
  );
};

export default Blockquote;
